import { createIntList } from "@utils/misc/functions";

// FIXME: In the future, these coupons can be fetched directly from Chargebee
// For go-to-market strategy, we'll do with hardcoded values
export const ipbCouponChoicesAU = createIntList(2, 25, 2).map((item) => ({
  label: `\$${item}`,
  value: `${item}`,
  enabled: true,
}));

export const ipbCouponChoicesUK = createIntList(1, 50, 1).map((item) => ({
  label: `\£${item}`,
  value: `${item}`,
  enabled: true,
}));
